import { debounce } from 'lodash';
import PropTypes from "prop-types";
import { Badge } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useRef, useState, useMemo } from "react";
import { useNavigate } from 'react-router-dom';

import useOnClickOutside from "../../hooks/useOnClickOutside";
import { setSearchKey } from "../../store/actions/SearchAction";

import Search from "../../images/icons/feather_search.svg?react";
import SearchSetting from "../../images_new/icon/codicon_settings.svg?react";
import { isAuthenticated } from '../../helpers/authentication/authentication';

const SearchInput = ({
  name,
  filterPopup,
  placeholder,
  showFilterPopup,
  ...props
}) => {
  const navigate = useNavigate();
  const inputRef = useRef();
  const dispatch = useDispatch();
  const [showFilter, setShowFilter] = useState(false);
  const search = useSelector((state) => state.search.filters);

  const handleFilterClick = () => {
    if (!isAuthenticated()) return navigate('/login')
    navigate('/search');
  }

  useEffect(() => {
    inputRef.current.focus();

    return () => {
      debouncedResults.cancel()
    }
  }, []);

  function handleFilterIcon() {
    if (!filterPopup) {
      setShowFilter(false);
      inputRef.current.focus();
    }
  }
  useOnClickOutside(inputRef, () => handleFilterIcon());

  const handleSearchInput = text => dispatch(setSearchKey(text))

  const debouncedResults = useMemo(() => {
    return debounce(handleSearchInput, 500)
  }, [handleSearchInput])

  return (
    <>
      <div
        className={showFilter ? "search-container-wide" : "search-container"}
        onClick={() => setShowFilter(true)}
        ref={inputRef}
      >
        <div>
          <span role="button" aria-label='search'>
            <Search />
          </span>
          <input
            type="search"
            name={name}
            placeholder={placeholder}
            aria-label="Search"
            {...props}
            onChange={(e) => {
              if (!isAuthenticated()) return navigate('/login')
              debouncedResults(e.target.value);
            }}
            ref={inputRef}
          />
        </div>
        {showFilter && !filterPopup ? (
          <Badge
            onClick={handleFilterClick}
            className="filter-icon"
            badgeContent={search.filterCount}
            color="primary"
          >
            <span
              as="button"
              aria-label='filter'
              id="filter"
              // onClick={() => showFilterPopup(!filterPopup)}
              onClick={handleFilterClick}
            >
              <SearchSetting />
            </span>
          </Badge>
        ) : null}
      </div>
    </>
  );
};

SearchInput.propTypes = {
  placeholder: PropTypes.string,
};

export default SearchInput;

